<nz-divider
    [nzText]="text"
    [nzOrientation]="textAlignment">
</nz-divider>